import { render, staticRenderFns } from "./LandlordView.vue?vue&type=template&id=24aee327"
import script from "./LandlordView.vue?vue&type=script&lang=js"
export * from "./LandlordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports